export default [
  'clickStartAChallenge',
  'completionPopupViewed',
  'quitChallenge',
  'startChallenge'
]
